<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-dialog
        title="状态修改"
        :visible.sync="openStatus"
        width="40%"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="24" >
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <el-form label-width="100px">
              <el-row>

                <el-col :span="24">
                  <validation-provider rules="required" name="状态" v-slot="{ errors }">
                    <el-form-item :error="errors[0]">
                      <el-radio-group v-model="form.active">
                        <div style="display: flex;align-items: center;flex-wrap: wrap;">
                          <el-button style="margin-right: 10px;margin-left: 0;margin-bottom: 10px;width: 100px;" v-for="(item, i) in statusList" :key="i">
                            <el-radio style="margin-bottom: 0;" :label="item.id">
                              {{item.name}}
                            </el-radio>
                          </el-button>
                        </div>
                      </el-radio-group>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="24">
                  <el-form-item>
                    <el-button type="primary" :disabled="submitIng" @click="handleSubmit(onSubmit)">
                      {{ submitIng ? '提交中...' : '提交' }}
                    </el-button>
                    <el-button @click="closeHandle">取消</el-button>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
          </validation-observer>
        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: '',
      },
      detail: {},
      statusList: [],
      form: {
        id: '',
        active: '',
      },
      submitIng: false,
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {},
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.form = {
        id: '',
        active: '',
      }
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminSimUpdateStatusDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.detail = res.detail;
            _this.form.active = parseInt(res.detail.active);
            _this.statusList = res.status_list;
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    onSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.form.id = _this.query.id;
      _this.$apiAdmin.adminSimUpdateStatus(_this.form)
          .then((res) => {
            _this.submitIng = false;
            _this.closeHandle();
            _this.$message.success('修改状态成功')
            _this.$emit('finish', res)
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg)
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.form = {
        id: '',
        active: '',
      }
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>